<div class="payment-refund-confirm-dialog-container" data-cy="ar-payment-refund-confirm">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;" data-cy="ar-payment-refund-confirm-section">
    <div class="section-header" style="flex-basis: 30px;" data-cy="ar-payment-refund-confirm-header">
      <div class="section-header-title" data-cy="ar-payment-refund-confirm-title">
        Patient Payment Refund
      </div>
      <div style="flex: 1;" data-cy="ar-payment-refund-confirm-header-spacer"></div>
    </div>

    <!--  MAIN AREA-->
    <div class="section-content" style="flex: 1;" data-cy="ar-payment-refund-confirm-content">

      @if (isLoading) {
        <app-tdo-progress-spinner style="flex: 1;" data-cy="ar-payment-refund-confirm-spinner"></app-tdo-progress-spinner>
      }

      @if (!isLoading) {
        <div data-cy="ar-payment-refund-confirm-loaded-content">
          <div style="display: flex;" data-cy="ar-payment-refund-confirm-payment-header">
            <div style="flex-basis: 100px;" data-cy="ar-payment-refund-confirm-payment-label"><span style=" font-size: 18px"><b>Payment</b></span></div>
            <div style="flex:1" data-cy="ar-payment-refund-confirm-full-amount-container">
              <div style="display: flex; flex-direction: row-reverse;" data-cy="ar-payment-refund-confirm-full-amount-wrapper">
                <div style="flex-basis: 170px" data-cy="ar-payment-refund-confirm-full-amount-checkbox-container">
                  <mat-checkbox
                    [(ngModel)]="refundFullAmount"
                    (click)="refundFullAmountClicked()"
                    data-cy="ar-payment-refund-confirm-full-amount-checkbox">
                    Refund Full Amount
                  </mat-checkbox>
                </div>
              </div>
            </div>
          </div>
          <div style="display: flex;" data-cy="ar-payment-refund-confirm-details-container">
            <div style="flex:1" data-cy="ar-payment-refund-confirm-payment-details">
              <div style="display: flex; flex-direction: column" data-cy="ar-payment-refund-confirm-payment-info">
                <div style="display: flex;" data-cy="ar-payment-refund-confirm-amount-row">
                  <div style="flex-basis: 100px" data-cy="ar-payment-refund-confirm-amount-label"><b>Amount:</b></div>
                  <div data-cy="ar-payment-refund-confirm-amount-value">{{ payment.ApprovedPaymentAmount | currency }}</div>
                </div>
                <div style="display: flex;" data-cy="ar-payment-refund-confirm-date-row">
                  <div style="flex-basis: 100px" data-cy="ar-payment-refund-confirm-date-label"><b>Date:</b></div>
                  <div data-cy="ar-payment-refund-confirm-date-value">{{ payment.PaymentTransactionDate | date }}</div>
                </div>
                <div style="display: flex;" data-cy="ar-payment-refund-confirm-from-row">
                  <div style="flex-basis: 100px" data-cy="ar-payment-refund-confirm-from-label"><b>From:</b></div>
                  <div data-cy="ar-payment-refund-confirm-from-value">{{ payment.PayerFirstName + ' ' + payment.PayerLastName  }}</div>
                </div>
                <div style="display: flex;" data-cy="ar-payment-refund-confirm-method-row">
                  <div style="flex-basis: 100px" data-cy="ar-payment-refund-confirm-method-label"><b>Method:</b></div>
                  <div data-cy="ar-payment-refund-confirm-method-value">{{ this.returnPaymentType() }}</div>
                </div>
              </div>
            </div>
            <div style="flex:1" data-cy="ar-payment-refund-confirm-refund-details">
              <div style="display: flex; flex-direction: column;" data-cy="ar-payment-refund-confirm-refund-info">
                <div style="display: flex;" data-cy="ar-payment-refund-confirm-refund-method-row">
                  <div style="flex-basis: 150px" data-cy="ar-payment-refund-confirm-refund-method-label"><b>Refund Method:</b></div>
                  <div style="flex:1" data-cy="ar-payment-refund-confirm-refund-method-value">
                    {{ refundMethod }}
                  </div>
                </div>
                <div style="display: flex;" data-cy="ar-payment-refund-confirm-refund-amount-row">
                  <div style="flex-basis: 150px" data-cy="ar-payment-refund-confirm-refund-amount-label"><b>Refund Amount:</b></div>
                  <div style="flex-basis: 100px" data-cy="ar-payment-refund-confirm-refund-amount-input-container">
                    <mat-form-field style="width:100px; font-weight: bold;" data-cy="ar-payment-refund-confirm-refund-amount-field">
                      @if (dummy) {
                        <input matInput
                          [disabled]="refundFullAmount"
                          [ngModel]="this.refundAmount | currency:'USD':'symbol'"
                          (change)="saveCurrencyField($event, 'refund', '', ''); setNewPaymentAmount(); setRefundAmountDistributionRemaining();"
                          autocomplete="off"
                          data-cy="ar-payment-refund-confirm-refund-amount-input">
                      }
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style="display: flex; margin-top:20px" data-cy="ar-payment-refund-confirm-distributions-header">
            <div style="flex:1" data-cy="ar-payment-refund-confirm-distributions-title"><span style=" font-size: 18px"><b>Payment Distributions</b></span></div>
            <div style="flex:1" data-cy="ar-payment-refund-confirm-refund-via-check-container">
              <div style="display: flex; flex-direction: row-reverse;" data-cy="ar-payment-refund-confirm-refund-via-check-wrapper">
                <div style="flex-basis: 155px" data-cy="ar-payment-refund-confirm-refund-via-check-checkbox-container">
                  <mat-checkbox
                    [(ngModel)]="refundViaCheck"
                    data-cy="ar-payment-refund-confirm-refund-via-check-checkbox">
                    Refund Via Check
                  </mat-checkbox>
                </div>
              </div>
            </div>
          </div>
          @if (!this.refundFullAmount) {
            <div style="display: flex; padding: 5px 5px 5px 10px; margin-bottom: 15px; margin-top: 15px; background-color: var(--tdo-blue-light)" data-cy="ar-payment-refund-confirm-notice">
              <div style="flex:1" data-cy="ar-payment-refund-confirm-notice-text">
                A portion of this payment will be refunded. Please revise the distribution of the payment.
                <br><b data-cy="ar-payment-refund-confirm-new-amount">The new payment amount will be {{ paymentAmountAfterRefund | currency:'USD':'symbol'}}</b>
              </div>
            </div>
          }
          <div [ngClass]="this.refundFullAmount ? 'tableHeightTall' : 'tableHeightShort'" data-cy="ar-payment-refund-confirm-table-container">
            <tdo-table [dataSource]="paymentDistributions"
              [isMultiSelection]="false" [isSearchable]="false" [isUsePaginator]="true"
              [searchPredicate]="searchPredicate" [footerData]=""
              data-cy="ar-payment-refund-confirm-distributions-table">
              <tdo-table-column displayName="Code" propertyName="Code" isSortable="true" [rowTemplate]="code" data-cy="ar-payment-refund-confirm-col-code">
                <ng-template #code let-row>
                  @if (row.model.Code) {
                    <div data-cy="ar-payment-refund-confirm-code">{{ row.model.Code }}</div>
                  }
                </ng-template>
              </tdo-table-column>
              <tdo-table-column displayName="PostDate" propertyName="PostDate" isSortable="true" [rowTemplate]="post" data-cy="ar-payment-refund-confirm-col-date">
                <ng-template #post let-row>
                  @if (row.model.PostDate) {
                    <div data-cy="ar-payment-refund-confirm-post-date">{{ row.model.PostDate | date }}</div>
                  }
                </ng-template>
              </tdo-table-column>
              <tdo-table-column displayName="Description" propertyName="Description" isSortable="true" [rowTemplate]="desc" data-cy="ar-payment-refund-confirm-col-desc">
                <ng-template #desc let-row>
                  @if (row.model.Description) {
                    <div data-cy="ar-payment-refund-confirm-description">{{ row.model.Description }}</div>
                  }
                </ng-template>
              </tdo-table-column>
              <tdo-table-column displayName="Amount" propertyName="Amount" [rowTemplate]="amount" data-cy="ar-payment-refund-confirm-col-amount">
                <ng-template #amount let-row>
                  @if (row.model.Amount) {
                    <div data-cy="ar-payment-refund-confirm-amount">{{ row.model.Amount | currency }}</div>
                  }
                </ng-template>
              </tdo-table-column>
              <!--            <tdo-table-column *ngIf="refundFullAmount" displayName="Refund" propertyName="RefundAmount" [rowTemplate]="refund">-->
              <tdo-table-column displayName="Refund" propertyName="RefundAmount" [rowTemplate]="refund" data-cy="ar-payment-refund-confirm-col-refund">
                <ng-template #refund let-row>
                  <mat-form-field style="width:100px; font-weight: bold;" data-cy="ar-payment-refund-confirm-refund-field">
                    <input matInput
                      [disabled]="false"
                      [ngModel]="row.model.RefundAmount | currency:'USD':'symbol'"
                      (change)="saveCurrencyField($event, 'dist', row.model.PaymetnDistributionID, ''); this.setRefundAmountDistributionRemaining();"
                      autocomplete="off"
                      data-cy="ar-payment-refund-confirm-refund-input">
                    </mat-form-field>
                  </ng-template>
                </tdo-table-column>
              </tdo-table>
            </div>
            @if (!this.refundFullAmount) {
              <div style="display: flex; padding: 5px 5px 5px 10px; margin-bottom: 15px; margin-top: 15px; background-color: var(--tdo-blue-light)" data-cy="ar-payment-refund-confirm-comment-section">
                <div style="flex:1" data-cy="ar-payment-refund-confirm-comment-container">
                  <div style="display: flex;" data-cy="ar-payment-refund-confirm-comment-row">
                    <div style="flex-basis: 85px" data-cy="ar-payment-refund-confirm-comment-label"><b>Comment:</b></div>
                    <div style="flex:1; padding-right: 20px" data-cy="ar-payment-refund-confirm-comment-input-container">
                      <mat-form-field style="width:100%;" data-cy="ar-payment-refund-confirm-comment-field">
                        <input matInput
                          [(ngModel)]="this.refundComment"
                          autocomplete="off"
                          data-cy="ar-payment-refund-confirm-comment-input">
                        </mat-form-field>
                      </div>
                      <div style="flex-basis:140px; text-align: right" data-cy="ar-payment-refund-confirm-balance-container">
                        <b data-cy="ar-payment-refund-confirm-balance">Balance: {{ this.refundAmountNotDistributed | currency:'USD':'symbol'}}</b>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          }

        </div>

        <!--  FOOTER-->
        <div class="section-footer" style="flex-basis: 60px; padding-top: 6px;" data-cy="ar-payment-refund-confirm-footer">
          <div style="flex: 1; margin-right: 6px;" data-cy="ar-payment-refund-confirm-footer-spacer"></div>
          <button [disabled]="refundButtonDisabled()" (click)="refundClick()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="ar-payment-refund-confirm-refund-btn">Refund</button>
          <button (click)="cancelClick()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="ar-payment-refund-confirm-cancel-btn">Cancel</button>
        </div>
      </div>
    </div>

